import React, { ReactNode } from 'react'
import { StepHeader } from '../../step-header/StepHeader'
import { Properties } from 'types/onboarding'
import { mapProductName } from 'onboarding/components/address/Address'
import { ErrorMessage } from 'onboarding/components/errormessage/ErrorMessage'
import s from '../Sign.module.scss'

const getSelectedPropertiesProductNames = (
  selectedPropertiesArray: Properties
) => {
  const productIds = new Set<string>()
  selectedPropertiesArray.forEach((property) => {
    if (property.product) {
      productIds.add(property.product)
    }
  })

  return Array.from(productIds)
    .map((productId) => {
      return mapProductName(productId)
    })
    .filter((productName) => !!productName)
}

type ProductNameListProps = {
  productNames: (
    | 'HleðsluOrka'
    | 'BílaOrka'
    | 'NæturOrka'
    | 'SparOrka'
    | 'GrænOrka'
    | undefined
  )[]
}

const ProductNameList = (props: ProductNameListProps) => {
  const { productNames } = props

  const productElements = productNames.map((productName, index) => {
    const trimmedName = productName?.replace('Orka', '')
    if (!trimmedName) {
      return null
    }

    return (
      <span
        key={`${trimmedName.toLowerCase()}-${index}`}
        className={s.productElement}
      >
        <strong>{trimmedName}</strong>Orka
      </span>
    )
  })

  return (
    <React.Fragment>
      {productElements.map((productElement, i, initial) => {
        return (
          <React.Fragment key={i}>
            {!!i && i !== initial.length - 1 && ', '}
            {!!i && i === initial.length - 1 && ' og '}
            {productElement}
          </React.Fragment>
        )
      })}
    </React.Fragment>
  )
}

interface StepTwoProps {
  selectedPropertiesArray: Properties
  setPdfRef: (node: HTMLDivElement) => void
  errorMessage: string
  loading: boolean
  children: ReactNode
}

const StepTwo = ({
  selectedPropertiesArray,
  setPdfRef,
  errorMessage,
  loading,
  children,
}: StepTwoProps) => {
  const productNames = getSelectedPropertiesProductNames(
    selectedPropertiesArray
  )

  return (
    <>
      <StepHeader title="Undirritun" />

      {productNames.length ? (
        <div className={s.productListTwo} ref={setPdfRef}>
          {productNames.length > 1
            ? 'Valdar orkuleiðir eru '
            : 'Valin orkuleið er '}
          <ProductNameList productNames={productNames} />
        </div>
      ) : (
        <div ref={setPdfRef} />
      )}

      {children}

      {errorMessage && !loading && (
        <>
          <br />
          <ErrorMessage message={errorMessage} />
        </>
      )}
    </>
  )
}

export default StepTwo
